import JSURL from 'jsurl';
import getConfig from 'next/config';

import buildAuthorizationHeader from './helpers/buildAuthorizationHeader';

/**
 * @param {Object} [params]
 * @param {Object} [params.options]
 * @param {string | undefined} [params.options.encodedParameters]
 * @param {string | undefined} [params.options.text]
 * @param {boolean | undefined} [params.options.includeTermCounts]
 * @param {boolean | undefined} [params.options.includeLocations]
 * @param {string[] | undefined} [params.options.termIds]
 * @param {number | undefined} [params.options.limit]
 * @param {number | undefined} [params.options.offset]
 * @param {string | undefined} [params.options.language]
 * @param {string | undefined} [params.options.cookie]
 * @param {GeoFilter | undefined} [params.options.geoFilter]
 * @param {boolean | undefined} [params.options.useLocationsFormat]
 * @param {number | undefined} [params.options.zoom]
 * @returns {Promise<JobSearchApiResponse>}
 */
const get = (options) => {
  const { publicRuntimeConfig } = getConfig();

  /**
   * @type {JobSearchApiHeaders}
   */
  const headers = {
    Accept: 'application/json',
    'Accept-Language':
      (options && options.language) || publicRuntimeConfig.defaultLanguage,
    Authorization: buildAuthorizationHeader(options && options.cookie),
  };

  let fetchUrl = `${publicRuntimeConfig.jobSearchApiBaseUrl}`;

  const createZoom = () => {
    if (options?.zoom && options.zoom <= 18) {
      return options.zoom + 2;
    }
    if (options?.zoom && options.zoom > 18 && options.zoom <= 21) {
      return options.zoom;
    }
    if (options?.zoom && options.zoom > 21) {
      return 21;
    }
    return 3;
  };

  const urlSearchParams = new URLSearchParams();
  if (options?.encodedParameters && options.encodedParameters !== '') {
    urlSearchParams.append('encodedParameters', options.encodedParameters);
    if (options?.limit) {
      urlSearchParams.append('limit', `${options.limit}`);
    }
    if (options?.offset) {
      urlSearchParams.append('offset', `${options.offset}`);
    }
    if (options?.includeTermCounts) {
      urlSearchParams.append('includeTermCounts', 'true');
    }
  } else {
    if (options?.text) {
      urlSearchParams.append('text', options.text);
    }
    if (options?.termIds) {
      urlSearchParams.append('termIds', JSURL.stringify(options.termIds));
    }
    if (options?.limit) {
      urlSearchParams.append('limit', `${options.limit}`);
    }
    if (options?.offset) {
      urlSearchParams.append('offset', `${options.offset}`);
    }
    if (options?.geoFilter) {
      urlSearchParams.append('geoFilter', JSURL.stringify(options.geoFilter));
    }
    if (options?.includeTermCounts) {
      urlSearchParams.append('includeTermCounts', 'true');
    }
    if (options?.includeLocations && options?.geoFilter) {
      urlSearchParams.append('includeLocations', 'true');
    }
    if (
      options?.includeLocations &&
      options?.geoFilter &&
      options?.useLocationsFormat
    ) {
      urlSearchParams.append(
        'locationsFormat',
        JSURL.stringify({
          type: 'CLUSTER',
          zoom: createZoom(),
          minClusterLocations: 2,
        }),
      );
    }
  }

  const query = urlSearchParams.toString();
  if (query) {
    fetchUrl += `?${query}`;
  }

  return fetch(fetchUrl, {
    headers,
  }).then((res) => {
    return res.json();
  });
};

export default {
  get,
};
